export default "__VITE_ASSET__FYYrJW5n__"